import { render, staticRenderFns } from "./editService.vue?vue&type=template&id=0627a57c&scoped=true&"
import script from "./editService.vue?vue&type=script&lang=js&"
export * from "./editService.vue?vue&type=script&lang=js&"
import style0 from "./editService.vue?vue&type=style&index=0&id=0627a57c&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0627a57c",
  null
  
)

export default component.exports